import React from 'react';
import './style.less';
import logo from '../../assets/img/home_logo.png';

const Home: React.FC = () => {
    return (
        <div className="survey">
            <div className="survey-logo">
                <img src={logo} alt="" />
            </div>
            <div className="title-home">
                <span>专注于服务千万医务人员</span>
                <span>专业的数字调研平台</span>
            </div>
        </div>
    );
};

export default Home;
